String.prototype.trim = function() {
  return String(this).replace(/^\s+|\s+$/g, '');
};

String.prototype.upper = function() {
  return String(this).toUpperCase();
};

String.prototype.lower = function() {
  return String(this).toLowerCase();
};

String.prototype.remove = function(toRemove) {
  return String(this).replace(toRemove, '');
}

String.prototype.replaceAll = function(toFind, toReplace) {
  return String(this).split(toFind).join(toReplace);
};

String.prototype.removeAll = function(toRemove) {
  return String(this).replaceAll(toRemove, '');
};

String.prototype.select = function() {
  return document.querySelector(String(this));
};

String.prototype.selectAll = function() {
  return [...document.querySelectorAll(String(this))]
};

String.prototype.first = function() {
  return String(this).slice(0, 1);
};

String.prototype.last = function() {
  return String(this).slice(-1);
};

String.prototype.toInt = function() {
  return parseInt(String(this).trim().removeAll(','));
};

String.prototype.node = function() {
  return document.createElement(String(this));
}